import workspaceQuery from 'graphql/queries/nominal/NominalBusinessCategoryWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/nominal/NominalBusinessCategoryListQuery.graphql';
import instanceQuery from 'graphql/queries/nominal/NominalBusinessCategoryQuery.graphql';
import defaultQuery from 'graphql/queries/nominal/NominalBusinessCategoryDefault.graphql';
import mutationQuery from 'graphql/mutations/nominal/NominalBusinessCategoryMutation.graphql';
import fragment from 'graphql/fragments/nominal/NominalBusinessCategoryFragment.graphql';

const NominalBusinessCategory = {
  type: 'NominalBusinessCategory',
  title: 'Nominal Business Categories',
  formTitle: 'Nominal Business Category',
  formUrl: '/Nominal/BusinessCategory/Details/',
  workspaceUrl: '/Nominal/BusinessCategory/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'NOMINAL_BUSINESS_CATEGORIES',
};

export default NominalBusinessCategory;
